import loadable from '@loadable/component';

export const HideOfferContainerLoadable = loadable(() => import('./HideOfferContainer'), {
  resolveComponent: ({ HideOfferContainer }) => HideOfferContainer,
});
